import React from "react";
import { Box, Text, Portal } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import MyLearningTabs from "./myLearningTabs";
import MobileMyLearningTabs from "./mobile-myLearningTabs";
import useMediaQ from "@root/hooks/useMediaQ";
import { useJournalistMyLearningTourGuide } from "@root/hooks/useJournalistMyLearningTourGuide";
import { TourGuide, RestartTourButton } from "@root/components/tour-guide";

const MyLearningDashboard: React.FC = () => {
  const { t } = useTranslation("common");
  const { sm, isMobileView } = useMediaQ();
  const isMobile = !sm;
  const { journalistMyLearningTourGuide, isMobile: isMobileTour } =
    useJournalistMyLearningTourGuide();

  return (
    <Box py={4} px={8} bg="#fafbfc" minW={"full"} minH="100vh">
      <Box minW={"full"} mx="auto">
        <>
          {" "}
          <Text fontWeight={600} fontSize={"24px"} color={"#2F2F34"} mb={1}>
            {isMobileView
              ? t("myLearningDashboard.mobileTitle")
              : t("myLearningDashboard.title")}
          </Text>
          <Text fontSize="16px" fontWeight={400} textColor={"#798692"} mb={6}>
            {isMobileView
              ? t("myLearningDashboard.mobileSubtitle")
              : t("myLearningDashboard.subtitle")}
          </Text>
        </>

        <MyLearningTabs />
      </Box>

      {!isMobileTour && !journalistMyLearningTourGuide.isActive && (
        <Portal>
          <RestartTourButton
            onClick={journalistMyLearningTourGuide.startTour}
            position={{ bottom: "24px", right: "24px" }}
          />
        </Portal>
      )}

      {!isMobileTour &&
        journalistMyLearningTourGuide.isActive &&
        journalistMyLearningTourGuide.currentStepData && (
          <TourGuide
            isActive={journalistMyLearningTourGuide.isActive}
            currentStep={journalistMyLearningTourGuide.currentStepData}
            currentStepIndex={journalistMyLearningTourGuide.currentStep}
            totalSteps={journalistMyLearningTourGuide.totalSteps}
            onNext={journalistMyLearningTourGuide.nextStep}
            onBack={journalistMyLearningTourGuide.previousStep}
            onClose={journalistMyLearningTourGuide.stopTour}
            targetSelector={
              journalistMyLearningTourGuide.currentStepData.targetSelector
            }
            borderRadius="8px"
          />
        )}
    </Box>
  );
};

export default MyLearningDashboard;
